import type {
  FundingCurrencyDiagnostic,
  FundingFunnelEvent,
  FundingLifecycleEvent,
  FundingTelemetryOptions,
} from '@morfi/onramp-sdk';
import { onEvent } from '@/events/index';
import { logger } from '@/lib/telemetry/logger';

export const fundingTelemetry: FundingTelemetryOptions = {
  surface: 'web',
  emit: (event: FundingFunnelEvent): void => {
    onEvent('onramp_funnel', event);
    if (event.outcome === 'error')
      logger.warn('onramp.funnel_failed', { stage: event.stage, code: event.errorCode });
  },
  onDiagnostic: (event: FundingCurrencyDiagnostic): void =>
    logger.warn(event.event, {
      currency: event.currency,
      reason: event.reason,
      ...(event.providerCurrency ? { providerCurrency: event.providerCurrency } : {}),
    }),
  onLifecycle: (event: FundingLifecycleEvent): void =>
    logger.info('onramp.session_lifecycle', event),
  onFailure: (code: 'onramp_telemetry_failed'): void =>
    logger.warn('onramp.telemetry_failed', { code }),
};
